import LandingSection from './LandingSection';

export default LandingSection;